import React, { Dispatch } from 'react';
import classNames from 'classnames';

import { StringIndexed } from 'types/table';
import { getObjectDeepValue } from 'helpers/getObjectDeepValue';
import { IInfoTableColumn, IInfoTableRow } from 'types/info-table';

import styles from './styles.module.css';

interface IInfoTableRowProps<T> {
  isSelected?: boolean;
  row: IInfoTableRow<T>;
  columns: IInfoTableColumn<T>[];
  onRowClick?: Dispatch<StringIndexed<T>>;
}

export const InfoTableRow = <T,>(props: IInfoTableRowProps<T>) => {
  const { isSelected, row, columns, onRowClick } = props;

  const cellClassname = classNames(styles.cell, { [styles.selected]: !!isSelected });

  const handleRowClick = () => (onRowClick ? onRowClick(row) : undefined);

  const renderCell = (column: IInfoTableColumn<T>) => {
    const cellValue = getObjectDeepValue(row, column.accessorKey) || null;

    if (column.cell) {
      return column.cell({ value: cellValue, row });
    }

    return cellValue ? String(cellValue) : null;
  };

  return (
    <div
      id={`info-table-row-${row.id || row.index}`}
      className={`${styles.row} info-table-row`}
      onClick={handleRowClick}
    >
      {columns.map((column, index) => (
        <div
          className={cellClassname}
          key={index}
          style={{
            maxWidth: `${column.width ? `${column.width}px` : '100%'}`,
            minWidth: `${column.minWidth ? `${column.minWidth}px` : 'unset'}`,
          }}
        >
          {renderCell(column)}
        </div>
      ))}
    </div>
  );
};
